var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonsterIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 106,
    viewBox: "0 0 86 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12387_385806)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 106,
    fill: "#921ECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2189 81.0025C-19.3427 84.267 -25.3314 83.5719 -28.5973 79.449C-31.8632 75.326 -31.1693 69.3367 -27.0462 66.0713C-22.9216 62.8078 5.64386 45.6221 8.90899 49.7441C12.1739 53.8679 -11.0976 77.7368 -15.2189 81.0025Z",
    fill: "#DB1375"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M-16.5086 78.5473C-19.5397 80.9464 -23.9424 80.4364 -26.3446 77.406C-28.744 74.375 -28.2325 69.9728 -25.2023 67.5727C-22.171 65.1718 -1.17449 52.5422 1.22514 55.5714C3.62634 58.6026 -13.4783 76.1472 -16.5086 78.5473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.574 117.481C85.6179 122.635 90.6462 125.968 95.7999 124.923C100.953 123.877 104.286 118.852 103.24 113.697C102.193 108.544 91.446 76.9876 86.2936 78.0322C81.139 79.0785 83.5286 112.327 84.574 117.481Z",
    fill: "#DB1375"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.1444 116.438C87.9136 120.226 91.6086 122.676 95.3948 121.909C99.1846 121.139 101.634 117.446 100.866 113.658C100.098 109.868 92.1952 86.6734 88.4064 87.4412C84.6191 88.2099 86.3764 112.65 87.1444 116.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6797 104.153C92.5301 99.0911 93.8923 94.3811 94.7807 89.9868C95.3844 91.3455 95.983 92.7589 96.5627 94.187C95.6128 98.1561 94.3335 102.352 92.7097 106.794C90.9683 111.558 88.7263 116.357 86.1187 121.059C85.3685 120.005 84.8213 118.783 84.5483 117.433C84.5458 117.422 84.5415 117.404 84.5379 117.392C86.9737 113.031 89.0629 108.576 90.6797 104.153Z",
    fill: "#B21F5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7907 64.0737C92.2668 65.8785 86.3799 65.1801 85.6393 62.5134C84.9039 59.8465 89.5933 56.2222 96.1184 54.4171C102.643 52.6108 108.53 53.308 109.268 55.9754C110.008 58.6409 105.316 62.2659 98.7907 64.0737Z",
    fill: "#DB1375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8539 73.2845C86.5031 70.9347 82.1347 66.9272 83.095 64.3316C84.055 61.7371 89.981 61.5385 96.3306 63.8878C102.68 66.2372 107.05 70.2451 106.088 72.8403C105.128 75.4348 99.2035 75.6338 92.8539 73.2845Z",
    fill: "#DB1375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2847 49.5679C82.0489 54.8472 80.3599 60.5306 82.5194 62.2638C84.6796 63.9943 89.8625 61.118 94.1003 55.8403C98.3359 50.5592 100.025 44.8758 97.8646 43.1436C95.7052 41.4122 90.5203 44.2868 86.2847 49.5679Z",
    fill: "#DB1375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03278 30.8966C11.8539 36.4822 16.8041 39.7461 19.0889 38.1864C21.3719 36.6218 20.1254 30.8277 16.3028 25.24C12.4806 19.6505 7.53288 16.388 5.24774 17.9494C2.96365 19.5102 4.21158 25.3064 8.03278 30.8966Z",
    fill: "#DB1375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6295 41.7652C12.9985 44.0652 18.9228 43.8202 19.8616 41.2167C20.8012 38.6149 16.4016 34.6416 10.0326 32.3416C3.66475 30.0421 -2.25952 30.2871 -3.19835 32.8906C-4.13795 35.4925 0.261685 39.4657 6.6295 41.7652Z",
    fill: "#DB1375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9422 27.874C26.7736 34.6417 24.3994 40.0734 21.6324 40.0054C18.8655 39.9361 16.7579 34.3941 16.9252 27.6277C17.0938 20.86 19.4681 15.4283 22.235 15.4976C25.002 15.5656 27.1096 21.1063 26.9422 27.874Z",
    fill: "#DB1375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4135 103.098C103.909 68.9167 89.7885 53.9857 55.6018 41.4887C21.4186 28.9929 0.995613 31.2966 -11.4995 65.478C-20.4804 90.046 -16.9843 126.782 -3.3595 131.933C7.54746 136.056 9.66859 127.391 22.4802 132.096C35.1246 136.742 30.3605 145.213 40.3748 148.786C57.747 154.983 81.6357 129.846 91.4135 103.098Z",
    fill: "#DB1375"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M100.979 72.5548C101.755 70.4558 98.5074 67.2904 93.5969 65.2192C93.9453 65.1392 94.2989 65.0489 94.6522 64.9519C100.311 63.3882 104.378 60.2434 103.738 57.93C103.099 55.6183 97.9917 55.0133 92.3337 56.5786C91.9799 56.6769 91.6331 56.7818 91.2926 56.8916C94.439 52.5915 95.5973 48.207 93.8495 46.8058C91.9773 45.3025 87.4836 47.7984 83.8077 52.3751C80.1339 56.9538 78.673 61.8823 80.5433 63.3834C81.1836 63.8976 82.1323 63.9441 83.2476 63.5976L83.2499 63.6025C82.1343 63.8761 81.3576 64.3908 81.0592 65.137C74.9804 59.4011 65.2529 55.0803 52.3583 50.3666C39.844 45.792 29.8477 42.8583 21.6421 43.1139C21.7569 42.4165 21.4811 41.6234 20.8867 40.8068C20.8867 40.8068 20.8895 40.8065 20.8899 40.8053C20.8899 40.8053 20.8927 40.805 20.8932 40.8038C21.522 41.7879 22.2771 42.3642 23.0981 42.3842C25.4979 42.444 27.5576 37.7344 27.7028 31.8658C27.8463 25.9979 26.0205 21.1919 23.6202 21.1333C21.3831 21.0778 19.4395 25.1752 19.0697 30.4904C18.8815 30.1872 18.6829 29.883 18.4759 29.5797C15.1613 24.7345 10.8704 21.9041 8.88865 23.2577C6.90882 24.6133 7.98997 29.6401 11.3038 34.4837C11.5113 34.7858 11.7233 35.0828 11.9368 35.3682C6.84818 33.7842 2.32628 34.1096 1.56517 36.2137C0.749662 38.4704 4.56625 41.9167 10.0893 43.9114C11.1389 44.2897 12.174 44.59 13.171 44.8103C5.82136 47.8124 0.160499 55.0007 -4.66044 68.1888C-15.7619 98.5578 -7.69266 120.462 22.6767 131.563C53.046 142.665 73.3393 131.129 84.4408 100.76C89.3017 87.4625 89.5769 78.2759 85.8011 71.2177C86.9022 71.8532 88.1496 72.4385 89.5026 72.9412C95.0077 74.9778 100.146 74.8049 100.979 72.5548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 39.5896,
    cy: 85.1841,
    rx: 51.0052,
    ry: 47.6159,
    transform: "rotate(20.08 39.5896 85.1841)",
    fill: "url(#paint0_radial_12387_385806)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4906 88.27C23.5264 82.7998 15.3023 68.8026 13.1867 58.3635C12.74 67.8497 20.4126 85.5699 37.2304 91.7176C53.9174 97.8176 71.4243 89.1915 77.1727 81.646C68.791 88.2747 53.3397 93.6981 38.4906 88.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6567 87.8151C23.6924 82.3449 15.4679 68.3488 13.3527 57.9086C12.9056 67.396 20.5778 85.1173 37.3955 91.2651C54.0826 97.3651 71.5904 88.7366 77.3383 81.1923C68.9566 87.8209 53.5057 93.2432 38.6567 87.8151Z",
    fill: "#6D0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4296 55.7742C80.9905 73.3888 61.1396 82.3216 43.0875 75.7226C25.0389 69.1249 15.6254 49.4944 22.0644 31.8798C28.5035 14.2652 48.3579 5.33362 66.4065 11.9313C84.4587 18.5303 93.8686 38.1596 87.4296 55.7742Z",
    fill: "#DB1375"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.7745 53.5549C77.1506 68.9396 60.1187 76.8519 44.7327 71.2275C29.3467 65.6031 21.4329 48.5719 27.0568 33.1872C32.6807 17.8026 49.7126 9.89028 65.0986 15.5147C80.4846 21.1391 88.3984 38.1703 82.7745 53.5549Z",
    fill: "url(#paint1_radial_12387_385806)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.6817 50.5948C70.6921 61.5087 58.6096 67.1217 47.6948 63.1317C36.78 59.1418 31.166 47.0599 35.1556 36.146C39.1452 25.2321 51.2276 19.6191 62.1424 23.6091C73.0572 27.599 78.6713 39.6809 74.6817 50.5948Z",
    fill: "url(#paint2_radial_12387_385806)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1584 46.7493C62.2919 51.8553 56.6411 54.4804 51.5346 52.6137C46.4281 50.747 43.8025 45.0965 45.669 39.9904C47.5351 34.8856 53.1863 32.2593 58.2928 34.126C63.3993 35.9927 66.0245 41.6444 64.1584 46.7493Z",
    fill: "#49482A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M57.2591 123.357C54.3811 131.23 39.5749 133.053 24.1889 127.429C8.80522 121.805 -1.33658 110.862 1.54139 102.989C4.41849 95.1183 19.227 93.2954 34.6107 98.919C49.9968 104.543 60.1362 115.486 57.2591 123.357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.4834,
    cy: 33.6074,
    rx: 11.7147,
    ry: 9.00036,
    transform: "rotate(20.08 58.4834 33.6074)",
    fill: "url(#paint3_radial_12387_385806)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_12387_385806",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.5896 80.3596) rotate(90) scale(52.3479 47.8677)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224916,
    stopColor: "#E4E4E4",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521135,
    stopColor: "#C57730",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_12387_385806",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.9161 43.3709) rotate(20.08) scale(29.6618 29.6593)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_12387_385806",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.9181 43.3706) rotate(20.08) scale(21.0421 21.0403)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9757EE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_12387_385806",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.4834 52.5574) rotate(-90) scale(27.9504 36.3795)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#2E2A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#2E2A49",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "#B0C5FB",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12387_385806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 106,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonsterIcon3);
export default __webpack_public_path__ + "static/media/MonsterIcon3.cc4d257740c43861c8937ea3c14f8225.svg";
export { ForwardRef as ReactComponent };